module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-container-single element-non-bodymatter element-type-toc toc-with-volume-author",
    attrs: {
      "epub:type": "toc",
      "id": "table-of-contents",
      "role": "doc-toc"
    }
  }, [_c('div', {
    staticClass: "toc-heading"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents"
  }, [_c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Kristen Bickerstaff")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol001"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("The Wish Shore")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Ken Hoover")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol002"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("The Wreckers")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("L.V. Bell")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Scourge")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Tracy Leonard Nakatani")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("The Pirate’s Cat")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("David Cole")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Annie Spark and the Pirates of Port 1337")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Linda Maye Adams")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Tidying Magic")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Trisha J. Wooldridge")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("By Stars and by Gears")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Amy Hughes")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Porch Pirates of Pasadena")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Jessica Guernsey")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Sabbath")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Tanya Hales")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("A Good Pirate’s Final Storm")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("John D. Payne")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Percival Bunnyrabbit and the Robot Wizard")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Lauren Lang")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Plundering Lives")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Melissa Koons")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Time Comes for All Men")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Elmdea Adams")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Life Pirate")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Jace Killan")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol015",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Pirated RPG")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Clint Hall")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol016",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Breath of the Cherubim")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Nancy DiMauro")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol017",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Princess Yum Yum’s Challenge")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("C.H. Hung")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol018",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Where We Will All Go")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Mary Pletsch")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol019",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Silver Future")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Julie Frost")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol020",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Sea Wolves")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Robert J. McCarter")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol021",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Harry the Ghost Pirate")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheeditor",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("About the Editor")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/ifyouliked",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("If You Liked …")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('span', {
    attrs: {
      "href": "#/otherwordfirepresstitleseditedbylisamangum",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Other WordFire Press Titles Edited by Lisa Mangum")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0